var initializeDataToggle;

(function($) {

    /**
     * Binds click event to a button, which opens and closes the data section
     *
     * @param button element which should trigger the event, expects jQuery object
     * @param box element which the trigger should be applied on, expects jQuery object
     */
    initializeDataToggle = function(button, box) {
        // check if button and data-box exist and on mobile device
        if(button.length && box.length && $(window).width() < 768) {

            // close box on default
            button.removeClass('active');
            box.removeClass('box-open');
            box.addClass('box-closed');

            // click event
            button.on('click', function (e) {
                e.preventDefault();
                
                // check if data-box is opened or closed
                if(button.hasClass('active')) {
                    button.removeClass('active');
                    box.removeClass('box-open');
                    box.addClass('box-closed');
                } else {
                    button.addClass('active');
                    box.removeClass('box-closed');
                    box.addClass('box-open');
                }
            })
        }
    }

})(jQuery);